import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'

const WishlistLabel = ({ isInWishlist, toggleWishlist }) => (
  <Icon
    iconName={
      isInWishlist
        ? 'icon_wishlist_color'
        : 'icon_wishlist'
    }
    className='card-wishlist txt-body-lg cursor pos-absolute r-0 t-1'
    onClick={toggleWishlist}
    alt='Favoritar este item '
  />
)

WishlistLabel.propTypes = {
  isInWishlist: PropTypes.bool.isRequired,
  toggleWishlist: PropTypes.func.isRequired
}

WishlistLabel.defaultProps = {
  isInWishlist: false
}

export default WishlistLabel



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/WishlistLabel/WishlistLabel.js